import { Component, OnInit } from '@angular/core';
import { ToasterService } from 'app/shared/service/toaster.service';
import { ClockInOutInfoDto } from 'shared/service-proxies/models/ClockInOutInfoDto';
import { ThumbApplicationType } from 'shared/service-proxies/service-proxies';
import { AttendanceService } from 'shared/service-proxies/services/attendance.service';

@Component({
  selector: 'app-attendance',
  templateUrl: './attendance.component.html',
  styleUrls: ['./attendance.component.scss']
})
export class AttendanceComponent implements OnInit {
  clockInOutInfo: ClockInOutInfoDto[];
  isClockIn: boolean = false;
  filterDialog: boolean = false;
  confirmationDialog: boolean = false;
  isQrDialogVisible: boolean = false;
  qrImage: string;
  ThumbApplicationType = ThumbApplicationType;
  selectedMonth: Date;

  constructor(
    private _attendanceService: AttendanceService,
    private toasterService: ToasterService,
  ) {

  }

  ngOnInit(): void {
    this.clockInOut();
  }

  openFilter() {
    this.filterDialog = true;
  }

  openConfirmation() {
    this.confirmationDialog = true;
  }

  hideDialog(): void {
    this.filterDialog = false;
    this.confirmationDialog = false;
  }

  showQrDialog() {
    this.generateQRForAttendance();
    this.isQrDialogVisible = true;
  }

  hideQrDialog() {
    this.isQrDialogVisible = false;
  }

  clockInOut() {
    const month = this.selectedMonth ? this.selectedMonth.getMonth() + 1 : undefined;
    const year = this.selectedMonth ? this.selectedMonth.getFullYear() : undefined;
    this._attendanceService.clockInOutInfo(month, year).subscribe(response => {
      if (response.isSuccess) {
        this.clockInOutInfo = response.responseData?.clockInOutTimeDto || [];
        this.isClockIn = response.responseData?.isClockIn || false;
        this.filterDialog = false;
        window.dispatchEvent(new Event('resize'));
      } else {
        this.toasterService.showApiValidation(response);
      }
    });
  }

  formatTotalTime(timeSpan: string): string {
    if (!timeSpan) {
      return 'N/A';
    }
    const [hours, minutes, seconds] = timeSpan.split(':');
    return `${hours}h ${minutes}m ${Math.floor(Number(seconds))}s`;
  }

  createClockInOrOutEntry(thumbType: ThumbApplicationType) {
    this._attendanceService.createClockInOrOutEntry(thumbType).subscribe({
      next: (response: any) => {
        if (this.isClockIn) {
          this.toasterService.toastSuccess("Clock-out successfully");

        } else {
          this.toasterService.toastSuccess("Clock-in successfully");
        }
        this.confirmationDialog = false;
        this.clockInOut();
      },
      error: (err) => {
        console.error('API Error:', err);
        this.toasterService.showApiValidation(err);
      },
    });
  }

  isToday(date: string): boolean {
    const today = new Date();
    const thumbDate = new Date(date);
    return (
      today.getFullYear() === thumbDate.getFullYear() &&
      today.getMonth() === thumbDate.getMonth() &&
      today.getDate() === thumbDate.getDate()
    );
  }

  generateQRForAttendance() {
    this._attendanceService.generateQRForAttendance().subscribe({
      next: (response: any) => {
        if (response && response.isSuccess) {
          this.qrImage = response.responseData;
        }
      },
      error: (err) => {
        console.error('API Error:', err);
        this.toasterService.showApiValidation(err);
      },
    });
  }

}